// Date Helper Functions untuk Operasi Otomatis
import { OPERATIONS_CONFIG } from '../config/operationsConfig';

export const COMPANY_START_DATE = new Date(OPERATIONS_CONFIG.companyStartDate); // Tanggal mulai operasi

// Menghitung bulan beroperasi otomatis
export const getOperatingMonths = () => {
  const now = new Date();
  const diffTime = Math.abs(now - COMPANY_START_DATE);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  const diffMonths = Math.ceil(diffDays / 30); // Bulan berjalan
  return diffMonths || 1; // Minimal 1 bulan
};

// Menghitung tahun beroperasi otomatis (untuk konteks lain)
export const getOperatingYears = () => {
  const now = new Date();
  const diffTime = Math.abs(now - COMPANY_START_DATE);
  const diffYears = diffTime / (1000 * 60 * 60 * 24 * 365);
  return Math.floor(diffYears) || 0; // Bisa 0 karena belum 1 tahun
};

// Format tanggal dalam bahasa Indonesia
export const formatDateIndo = (date) => {
  const options = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric',
    timeZone: 'Asia/Jakarta'
  };
  return new Date(date).toLocaleDateString('id-ID', options);
};

// Mendapatkan bulan dan tahun saat ini
export const getCurrentMonthYear = () => {
  const now = new Date();
  const options = { 
    year: 'numeric', 
    month: 'long',
    timeZone: 'Asia/Jakarta'
  };
  return now.toLocaleDateString('id-ID', options);
};

// Mendapatkan tahun saat ini
export const getCurrentYear = () => {
  return new Date().getFullYear();
};

// Menghitung durasi dari tanggal tertentu hingga sekarang
export const getDurationFrom = (startDate) => {
  const start = new Date(startDate);
  const now = new Date();
  const diffTime = Math.abs(now - start);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays < 30) {
    return `${diffDays} hari`;
  } else if (diffDays < 365) {
    const months = Math.floor(diffDays / 30);
    return `${months} bulan`;
  } else {
    const years = Math.floor(diffDays / 365);
    const remainingMonths = Math.floor((diffDays % 365) / 30);
    return remainingMonths > 0 ? `${years} tahun ${remainingMonths} bulan` : `${years} tahun`;
  }
};

// Update otomatis untuk statistik
export const getCompanyStats = () => {
  return {
    operatingYears: getOperatingYears(),
    currentYear: getCurrentYear(),
    currentMonthYear: getCurrentMonthYear()
  };
};
